<template>
    <AppBase>
        <component :is="`module-${$route.params.module}-${$route.params.page}`"></component>
    </AppBase>
</template>

<script>
    import AppBase from '@/components/AppBase';
    import router from '@/router';
    import { findIndex } from 'lodash';

    const exists = (to) => {
        const component = `module-${to.params.module}-${to.params.page}`;
        return component in router.app.$options.components;
    };

    const history = (to, from, prev) => {
        const next = { from: from.path, to: to.path, enter: new Date() };
        if (prev) {
            prev.leave = next.enter;
        }
        return next;
    };

    export default {
        name: 'Module',
        components: { AppBase },
        data: () => ({
            history: [],
            module: null,
            repeat: false
        }),
        computed: {
            prev() {
                return this.history.length ? this.history[this.history.length - 1] : null;
            }
        },
        mounted() {
            let completed = this.$store.get('completed');
            let idx = findIndex(completed, { id: this.section });

            if (idx > -1) {
                this.repeat = this.$store.get(`section${this.section}/complete`);
            }
        },
        beforeRouteEnter(to, from, next) {
            if (!exists(to)) {
                return next({ name: 'home', replace: true });
            }
            next((vm) => {
                vm.history = [history(to, from)];
                vm.module = vm.$store.get('module', to.params.module);
            });
        },
        beforeRouteUpdate(to, from, next) {
            if (!exists(to)) {
                return next({ name: 'home', replace: true });
            }
            this.history.push(history(to, from, this.prev));
            next();
        },
        beforeRouteLeave(to, from, next) {
            this.history.push(history(to, from, this.prev));
            next();
        },
        async beforeDestroy() {
            try {
                await this.$api.post('/history', {
                    module: this.module,
                    history: this.history,
                    repeat: this.repeat
                });
            } catch (error) {
                // nothing
            }
        }
    };
</script>
